<template>
    <div :class="[isShowShare || isShowClose ? 'aia-header-with-icon' : 'aia-header']">
        <div class="aia-back" 
            @click="clickBack" v-if="isShowBlack">
            <img class="img-fluid"  src="@/assets/icon/ic-arrow-left-grey.svg" />
        </div>
        <div id="mass_text" class="aia-text">
            {{headerText}}
        </div>
        <!-- <div class="aia-search"
            @click="clickSearch()">
            <img src="../../../../assets/icon/ic_search.svg" v-if="showSearch" />
        </div> -->
        <div class="icon-box">
            <div class="aia-share"
                @click="clickShare()">
                <img src="../../../../assets/icon/ic-share-social.svg" v-if="isShowShare" />
            </div>
            <div class="aia-close"
                @click="clickClose()">
                <img src="../../../../assets/icon/ic-close-gray.svg" v-if="isShowClose" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MassHeaderText',
    props: {
        headerText: String,
        showSearch: {type:Boolean, default:false},
        isShowShare: {type:Boolean, default:false},
        isShowClose: {type:Boolean, default:false},
        isShowBlack: {type:Boolean, default:true},
    },
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        },
        clickSearch: function () {
            this.$router.push('/search');
        },
        clickShare: function () {
            this.$emit('clickShare');
        },
        clickClose: function () {
            this.$emit('clickClose');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../AIAHeader.scss";
.aia-header {
    background-color: $color-white;

    #mass_text {
        color: $color-gray;
    }
}
</style>
